import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "hh-consent";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-lg z-[70] glass border border-gold/25 rounded-2xl p-5 shadow-2xl"
          data-testid="cookie-consent-bar"
          role="dialog"
          aria-label="Privacy notice"
        >
          <p className="text-xs sm:text-sm text-zinc-300 leading-relaxed">
            We keep it light — <span className="text-gold-pale">no tracking cookies</span>. Your checklist
            progress and concierge chat are stored only on this device (browser local storage), and admin
            sign-in uses one secure session cookie. Details in our{" "}
            <a href="/privacy" className="text-gold-light underline underline-offset-2 hover:text-gold-pale transition-colors"
               data-testid="cookie-consent-privacy-link">
              Privacy Policy
            </a>.
          </p>
          <button
            onClick={accept}
            data-testid="cookie-consent-accept-btn"
            className="mt-3.5 rounded-full bg-gold px-5 py-2 text-xs font-semibold text-ink hover:bg-gold-hover transition-colors"
          >
            Got it
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
